import { timeAgo } from "@/lib/format";
import { Activity } from "lucide-react";

const Card = ({ title, children, testid }) => (
  <div className="bg-white border border-slate-200/80 rounded-xl shadow-sm p-5" data-testid={testid}>
    <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">{title}</h3>
    {children}
  </div>
);

export function PartnerPerformance({ rows = [], conversion, workingNow }) {
  return (
    <Card title="Partner performance" testid="partner-performance">
      <div className="space-y-3">
        {rows.map((p, i) => (
          <div key={i} className="flex items-center justify-between text-sm">
            <span className="font-medium text-slate-700">{p.name}</span>
            <span className="text-slate-500">{p.leads} leads · {p.won} won</span>
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-slate-400">No partners yet</p>}
      </div>
      <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-2 gap-3 text-center">
        <div><div className="text-xl font-bold text-slate-900" data-testid="dash-conversion">{conversion}%</div><div className="text-xs text-slate-500">Conversion</div></div>
        <div><div className="text-xl font-bold text-slate-900" data-testid="dash-working-now">{workingNow}</div><div className="text-xs text-slate-500">Working now</div></div>
      </div>
    </Card>
  );
}

export function TeamPerformance({ rows = [] }) {
  return (
    <Card title="Team performance" testid="team-performance">
      <div className="space-y-3">
        {rows.map((p) => (
          <div key={p.user_id} className="flex items-center justify-between text-sm">
            <span className="font-medium text-slate-700 truncate">{p.name}</span>
            <span className="text-slate-500 shrink-0">{p.leads} leads · {p.won} won · {p.activities} acts</span>
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-slate-400">No team members assigned</p>}
      </div>
    </Card>
  );
}

export function RecentActivity({ rows = [] }) {
  return (
    <Card title={<><Activity className="h-5 w-5 text-teal" /> Recent activity</>} testid="recent-activity">
      <div className="space-y-3">
        {rows.map((a) => (
          <div key={a.id} className="flex items-start gap-3 text-sm">
            <div className="mt-1 h-2 w-2 rounded-full bg-teal shrink-0" />
            <div className="min-w-0">
              <div className="font-medium text-slate-700">{a.type} · {a.outcome || "—"}</div>
              <div className="text-xs text-slate-400 truncate">{a.lead_name ? `${a.lead_name} · ` : ""}{timeAgo(a.when || a.created_at)}</div>
            </div>
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-slate-400">No activity in this period</p>}
      </div>
    </Card>
  );
}
